// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GtinDetail_wrapper__3mVYy"};